import { consumeRedirectPath, buildWorkspaceRedirectUrl } from '@/services/redirectAfterLogin'

export default {
  methods: {
    redirectAfterLogin(defaultPath = '/') {
      const path = consumeRedirectPath(defaultPath)
      const url = buildWorkspaceRedirectUrl(this.user.domain, this.frontDomain, path)
      window.location = url
    },
  }
}
